import { render, staticRenderFns } from "./VrTagContents.vue?vue&type=template&id=33b18f26&"
import script from "./VrTagContents.vue?vue&type=script&lang=ts&"
export * from "./VrTagContents.vue?vue&type=script&lang=ts&"
import style0 from "./VrTagContents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports